import { sendApiRequest, shouldGetCourseDataFromCanvasAPIs } from '../lib/helper';
import { IAuthenticationStatusContext } from '../types/IAuthenticationStatusContext';
import { ICourse, ISemester } from "../types/ICourse";

export interface ICoursesResponse {
    Semester: ISemester,
    Courses: ICourse[];
}

export const getCourses = (semester: ISemester, authContext: IAuthenticationStatusContext): Promise<ICoursesResponse> => {

    return _getCoursesInternal(semester, authContext).then(courses => {
        return {
            Semester: semester,
            Courses: courses
        }
    })
}

export const getStudentsInCourse = (courseId: number) => {
    return sendApiRequest(`/api/canvas/getStudentsInCourse?courseId=${courseId}`, "GET").then(res => {
        return res.map((s: any) => s.sortable_name);
    });
}

const _getCoursesInternal = async (semester: ISemester, authContext: IAuthenticationStatusContext): Promise<ICourse[]> => {
    if(await shouldGetCourseDataFromCanvasAPIs(semester, authContext))
    {
        console.log(`Getting courses for ${semester.Year} ${semester.Semester} from Canvas`)
        return sendApiRequest("/api/canvas/getPublishedCourses", "POST", JSON.stringify({ semester: semester })).then(res => {
            if(typeof res === "object")
            {
                return res.map((c: ICourse) => {
                    const retVal: ICourse = { ...c };
                    return retVal;
                })
            }
            else
            {
                throw new Error(res);
            }
        });
    }
    else {      
        console.log(`Getting courses for ${semester.Year} ${semester.Semester} from Blob Storage`)  
        return sendApiRequest("/api/blobStorage/getCoursesFromBlobStorage", "POST", JSON.stringify({ semester: semester })).then(res => {
            if(typeof res === "object")
            {
                return res.map((c: ICourse) => {
                    const retVal: ICourse = { ...c };
                    return retVal;
                })
            }
            else
            {
                throw new Error(res);
            }
        });
    }
};

export const getCourse = async (sisId: string, courseId: string | number, semester: ISemester, authContext: IAuthenticationStatusContext): Promise<ICourse | undefined> => {
    if (semester) {
        return _getCoursesInternal(semester, authContext).then(res => {
            if(typeof res === "object")
            {
                let courses: ICourse[] = res.map((c: ICourse) => {
                    const retVal: ICourse = { ...c };
                    return retVal;
                });
                let retVal = courses.find(c => c.SIS === sisId || c.SIS === courseId);
                if(!retVal)
                {
                    retVal = courses.find(c => c.CanvasId === Number(sisId) || c.CanvasId === Number(courseId));
                }
                if(!retVal)
                {
                    console.info(`Unable to find '${sisId}' in list of known courses. Searched by SIS and Canvas ID.`, courses);
                }
                return retVal;
            }
            else
            {
                console.info("Get course internal came back with an invalid object type");
                throw new Error(res);
            }
        });
    }
    else
    {
        console.info("No semseter provided to getCourse");
        throw new Error("No semseter provided to getCourse");
    }
}